import { useSDKConfigStore } from "../stores/sdkConfigStore";
import { dataFetcher } from "../core/dataFetcher";
import { SwypeSDKConfig } from "./types";
import { useKycStore } from "../stores/useKycStore";

// Initialize SDK with configuration and pre-generated auth signature
export async function initializeSwypeSDK(
  config: SwypeSDKConfig
): Promise<void> {
  console.log("🚀 initializeSwypeSDK called with config:", config);

  // Store config in global store
  const { setConfig } = useSDKConfigStore.getState();
  const { setIsSumsubProfileVerified } = useKycStore.getState();
  setConfig({
    apiKey: config.apiKey,
    baseUrl: config.baseUrl,
    apiPath: config.apiPath,
    tenantId: config.tenantId,
    jwt: config.jwt,
  });

  try {
    // Now that authentication is complete, fetch configured data only
    setIsSumsubProfileVerified(false);
    await dataFetcher.fetchDataAfterAuth();
  } catch (error) {
    console.error("Failed to initialize SwypeSDK:", error);
    throw error;
  }
}
